<template>
    <div name="bottom-button">
        <div @click="onClick" class="button" ref="bottom-button">
            <span>{{text}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'bottomButton',
    props: ['text', 'color'],
    mounted: function()
    {
        this.$refs['bottom-button'].style.background = this.color;
        if(this.color === '#FFFFFF')
        {
            this.$refs['bottom-button'].style.color = '#000';
        }
        if(this.color === '#FFF')
        {
            this.$refs['bottom-button'].style.border = '1px solid var(--gray-40-button-stroke, #D1D6DB)';
            this.$refs['bottom-button'].style.color = '#000';
        }

        if(this.color === '#EDEEF0')
        {
            this.$refs['bottom-button'].style.color = '#A3AAB6';
        }
    },
    methods: {
        onClick: function()
        {
            this.$emit('onClick');
        }
    }
}
</script>

<style scoped>
    .button {
        display: flex;
        width: calc(100%);
        height: 56px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
        border-radius: 6px;

        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        cursor: pointer;
    }

</style>


// WEBPACK FOOTER //
// src/components/atoms/BottomButton.vue